<template>
  <div class="edit-site">
    <!-- Media Gallery and Map Section -->
    <div class="edit-site__header">
      <div class="edit-site__gallery">
        <media-gallery-v1
          :documentable-id="site.building.id"
          documentable-type="App\Building"
          :media="site.building.media" 
          :height="500"
        />
      </div>
      <div class="edit-site__map">
        <map-component  
          :latitude="site.building.latitude" 
          :longitude="site.building.longitude"    
          :zoom="6"
        />
      </div>
    </div>

    <!-- Tabs Navigation -->
    <div class="edit-site__tabs">
      <nav class="edit-site__tabs-nav" role="tablist" aria-label="Site information sections">
        <button
          v-for="(tab, index) in enabledTabs"
          :key="index"
          @click="activeTab = index"
          type="button"
          class="edit-site__tab"
          :class="{ 'edit-site__tab--active': activeTab === index }"
          role="tab"
          :aria-selected="activeTab === index"
          :aria-controls="`tab-panel-${index}`"
          :id="`tab-${index}`"
        >
          {{ tab.label }}
        </button>
      </nav>

      <!-- Tab Panels -->
      <div class="edit-site__tabs-content">
        <!-- Basic Information Tab -->
        <div 
          v-show="activeTab === 'basic'"
          class="edit-site__tab-panel"
          role="tabpanel"
          :aria-labelledby="`tab-basic`"
          id="tab-panel-basic"
        >
          <basic-site-information :site-data="site" />
        </div>

        <!-- Building Tab -->
        <div 
          v-show="activeTab === 'building'"
          class="edit-site__tab-panel"
          role="tabpanel"
          :aria-labelledby="`tab-building`"
          id="tab-panel-building"
        >
          <edit-building-details :building-data="site.building" />
        </div>

        <!-- Leases Tab -->
        <div 
          v-show="activeTab === 'leases'"
          class="edit-site__tab-panel edit-site__tab-panel--padded"
          role="tabpanel"
          :aria-labelledby="`tab-leases`"
          id="tab-panel-leases"
        >
          <leases :data="site" />
        </div>

        <!-- Utilization Tab -->
        <div 
          v-show="activeTab === 'utilization'"
          class="edit-site__tab-panel edit-site__tab-panel--padded"
          role="tabpanel"
          :aria-labelledby="`tab-utilization`"
          id="tab-panel-utilization"
        >
          <site-utilization :site-data="site" />
        </div>

        <!-- Documents Tab -->
        <div 
          v-show="activeTab === 'documents'"
          class="edit-site__tab-panel edit-site__tab-panel--padded"
          role="tabpanel"
          :aria-labelledby="`tab-documents`"
          id="tab-panel-documents"
        >
          <documents
            :document-data="site.documents"
            :documentable-id="site.id"
            documentable-type="App\Site"
          />
        </div>
      </div>
    </div>

    <notifications classes="notification" position="bottom right" />
  </div>
</template>

<script>
import MediaGalleryV1 from '../../MediaGallery.vue';

export default {
  name: 'EditSite',
  
  components: {
    MediaGalleryV1
  },
  
  props: {
    siteData: {
      type: Object,
      required: true
    },
    showTab: {
      type: String,
      default: 'basic'
    }
  },

  data() {
    return {
      site: this.siteData,
      activeTab: this.showTab
    };
  },

  computed: {
    tabs() {
      return {
        'basic': {
          label: 'Basic Information',
          enabled: true
        },
        'building': {
          label: 'Building',
          enabled: true
        },
        'leases': {
          label: 'Leases',
          enabled: this.site.lease_or_own === 'Leased'
        },
        'utilization': {
          label: 'Utilization',
          enabled: true
        },
        'contacts': {
          label: 'Contacts',
          enabled: false
        },
        'documents': {
          label: 'Documents',
          enabled: true
        }
      };
    },

    enabledTabs() {
      return Object.entries(this.tabs)
        .filter(([key, tab]) => tab.enabled)
        .map(([key, tab]) => ({ ...tab, key }));
    }
  }
};
</script>
